import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUiStore = defineStore(
  'ui-store',
  () => {
    const showAdminMenu = ref<boolean>(false)

    function toggleAdminMenu(status: boolean) {
      showAdminMenu.value = status
    }

    return { showAdminMenu, toggleAdminMenu }
  },
  {
    persist: true,
  },
)
